import axios from 'axios';
import { CommonState, isFetching } from './common';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { enqueueRequestErrorSnackbar } from '../actions/enqueueSnackbar';
import { IQuestion } from '../interfaces/question';
import { sendError } from '../sendError';

const name = 'incompleteGroupedQuestions';

type FetchParams = {
  organizationId: string;
  questionIds: string[];
};

export const fetchIncompleteGroupedQuestions = createAsyncThunk(
  `${name}/fetch`,
  async ({ organizationId, questionIds }: FetchParams, { dispatch }) => {
    try {
      const response = await axios.get<IQuestion[]>(`/api/questionnaire/v1/organizations/${organizationId}/questions`);

      const filteredResponse = response.data.filter(question => questionIds.includes(question.id));
      return filteredResponse;
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);

export type State = CommonState & {
  incompleteGroupedQuestions: IQuestion[];
};

const initialState: State = {
  isFetching: false,
  error: null,
  incompleteGroupedQuestions: []
};

const incompleteGroupedQuestions = createSlice({
  name,
  initialState,
  reducers: {
    clearIncompleteGroupedQuestions(state) {
      state.incompleteGroupedQuestions = [];
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchIncompleteGroupedQuestions.pending, isFetching)
      .addCase(fetchIncompleteGroupedQuestions.fulfilled, (state, action) => {
        state.incompleteGroupedQuestions = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchIncompleteGroupedQuestions.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.error;

        sendError(action.error);
      });
  }
});

export const {
  reducer: incompleteGroupedQuestionsReducer,
  actions: { clearIncompleteGroupedQuestions }
} = incompleteGroupedQuestions;
